import { useState } from "react";

import { Languages, Moon, Sun } from "lucide-react";
import { AnimatePresence, motion } from "motion/react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { LANGUAGES, currentLanguage } from "@/configs/i18n";
import { applyTheme, readTheme, type Theme } from "@/lib/theme";

const LANGUAGE_LABELS: Record<string, string> = { uz: "O'zbekcha", ru: "Русский", en: "English" };

export function HeaderControls() {
  const { t, i18n } = useTranslation();
  const [theme, setTheme] = useState<Theme>(readTheme);

  const toggleTheme = () => {
    const next = theme === "dark" ? "light" : "dark";
    applyTheme(next);
    setTheme(next);
  };

  return (
    <div className="flex items-center gap-1.5">
      <Select value={currentLanguage()} onValueChange={lang => void i18n.changeLanguage(lang)}>
        <SelectTrigger size="sm" aria-label={t("common.language")} className="w-36 rounded-xl">
          <Languages className="text-muted-foreground" />
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {LANGUAGES.map(lang => (
            <SelectItem key={lang} value={lang}>
              {LANGUAGE_LABELS[lang]}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Button
        variant="ghost"
        size="icon-sm"
        aria-label={t("common.theme")}
        onClick={toggleTheme}
        className="overflow-hidden rounded-xl"
      >
        {/* Quyosh va oy almashganda aylanib chiqib-kiradi. */}
        <AnimatePresence mode="wait" initial={false}>
          <motion.span
            key={theme}
            initial={{ y: 14, rotate: -90, opacity: 0 }}
            animate={{ y: 0, rotate: 0, opacity: 1 }}
            exit={{ y: -14, rotate: 90, opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="grid place-items-center"
          >
            {theme === "dark" ? <Sun /> : <Moon />}
          </motion.span>
        </AnimatePresence>
      </Button>
    </div>
  );
}
